<template>
    <v-container fluid>
        <v-btn
            :loading="representativeProductsWithInfo === null"
            @click="newRepresentativeProduct"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Representative Products ({{totalMatches}})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <!--<v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>-->
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="representativeProductsWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    lg="6"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="representativeProductWithInfo.entity.id"
                    cols="12"
                    lg="6"
                    v-for="representativeProductWithInfo in representativeProductsWithInfo"
                >
                    <!--@click="loadRepresentativeProductForm(representativeProductWithInfo.entity)"-->
                    <v-card
                        @click="loadRepresentativeProductForm(representativeProductWithInfo.entity)"
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow:hidden"
                    >
                        <v-card-subtitle>
                            Product Name: {{representativeProductWithInfo.entity.name}}
                            <br />
                            Product Code: {{representativeProductWithInfo.entity.code}}
                            <br />
                            Representative: {{getRepresentativeName(representativeProductWithInfo.entity.representativeId)}}
                            <br />
                            Subscription: {{getSubscriptionName(representativeProductWithInfo.entity.subscriptionId)}}
                        </v-card-subtitle>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            persistent
            v-model="representativeProductFormVisible"
            width="500px"
        >
            <RepresentativeProductForm
                :entity-in="representativeProductFormRepresentativeProduct"
                :key="representativeProductFormKey"
                @close="closeRepresentativeProductForm"
                @deleted="deleteRepresentativeProduct"
                @saved="updateRepresentativeProduct"
            />
        </v-dialog>

        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import RepresentativeProduct from "../models/RepresentativeProduct.model";
import uuid4 from "../helpers/uuid4";
import RepresentativeProduct from "../models/RepresentativeProduct.model";
import RepresentativeProductForm from "../components/forms/RepresentativeProductForm";

export default {
    name: "RepresentativeProducts",
    props: ["status"],
    data: function() {
        return {
            //main data
            representatives: [],
            subscriptions: [],
            representativeProductsWithInfo: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),

            //form
            representativeProductFormVisible: false,
            representativeProductFormKey: 0,
            representativeProductFormRepresentativeProduct: new RepresentativeProduct()
        };
    },
    mounted: async function() {
        this.representatives = await this.$store.dispatch(
            "representatives/getlist"
        );
        this.subscriptions = await this.$store.dispatch(
            "subscriptions/getlist"
        );

        this.paginationDebounce(500);
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        RepresentativeProductForm
        //
    },
    methods: {
        getSubscriptionName(id) {
            var i = this.subscriptions
                ? this.subscriptions.find(x => x.key == id)
                : null;
            return i ? i.value : "";
        },
        getRepresentativeName(id) {
            var i = this.representatives
                ? this.representatives.find(x => x.key == id)
                : null;
            return i ? i.value : "";
        },
        getRepresentativeProducts() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("representativeProducts/get", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder
                    },
                    requestId: requestId
                })
                .then(representativeProductsResponse => {
                    if (
                        this.requestId ==
                        representativeProductsResponse.requestId
                    ) {
                        this.representativeProductsWithInfo =
                            representativeProductsResponse.data.page;
                        this.totalMatches =
                            representativeProductsResponse.data.total;
                        this.pageSize =
                            representativeProductsResponse.data.pageSize;
                        this.pageNo =
                            representativeProductsResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            representativeProductsResponse.data.total /
                                this.pageSize
                        );
                    }
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.representativeProductsWithInfo !== null)
                this.representativeProductsWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getRepresentativeProducts,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },

        //FORM METHODS---------------------------------
        newRepresentativeProduct() {
            var representativeProduct = new RepresentativeProduct();
            representativeProduct.id = 0;
            this.loadRepresentativeProductForm(representativeProduct);
        },
        loadRepresentativeProductForm(representativeProduct) {
            this.representativeProductFormRepresentativeProduct = new RepresentativeProduct().set(
                representativeProduct
            );
            this.representativeProductFormKey = representativeProduct.id;
            this.representativeProductFormVisible = true;
        },
        closeRepresentativeProductForm() {
            this.representativeProductFormVisible = false;
            this.representativeProductFormRepresentativeProduct = new RepresentativeProduct();
            this.representativeProductFormKey = null;
        },
        updateRepresentativeProduct() {
            this.paginationDebounce(0);
        },
        deleteRepresentativeProduct() {
            this.paginationDebounce(0);
        }
    }
};
</script>

<style lang="stylus" scoped>
.entity-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
